var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition",
            app: ""
          },
          model: {
            value: _vm.planNPayOn,
            callback: function($$v) {
              _vm.planNPayOn = $$v
            },
            expression: "planNPayOn"
          }
        },
        [
          _vm.selectedLocation &&
          _vm.selectedLocation.nasid &&
          _vm.selectedLocation.nasid > 0
            ? _c("PlanAndPayment", {
                key: "PlanAndPayment::" + _vm.selectedLocation.nasid,
                attrs: {
                  owner: _vm.owner,
                  page: _vm.planNPayPage,
                  plans: _vm.defaultPlans,
                  selectedLocation: _vm.selectedLocation,
                  subscriptionName: _vm.selectedLocation.subscription.name,
                  settingId: _vm.settingId,
                  fromSettings: false
                },
                on: {
                  close: function($event) {
                    _vm.planNPayOn = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition",
            app: ""
          },
          model: {
            value: _vm.showPlans,
            callback: function($$v) {
              _vm.showPlans = $$v
            },
            expression: "showPlans"
          }
        },
        [
          _c("Plans", {
            attrs: { view: _vm.welcome },
            on: {
              close: function($event) {
                _vm.showPlans = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "90%" },
          model: {
            value: _vm.showTroubleShooting,
            callback: function($$v) {
              _vm.showTroubleShooting = $$v
            },
            expression: "showTroubleShooting"
          }
        },
        [
          _c("Troubleshoot", {
            on: {
              cancel: function($event) {
                _vm.showTroubleShooting = false
              }
            }
          })
        ],
        1
      ),
      _c("LocationSelector", {
        attrs: {
          storeData: _vm.storeData,
          selectedLocation: _vm.selectedLocation
        },
        on: {
          "select-location": function($event) {
            return _vm.setLocation($event)
          }
        }
      }),
      !_vm.selectedLocation ||
      !_vm.selectedLocation.nasid ||
      _vm.selectedLocation.nasid == 0
        ? _c("v-skeleton-loader", {
            attrs: { type: "list-item-two-line, image, image" }
          })
        : _vm._e(),
      _vm.selectedSection == "manage" &&
      _vm.selectedLocation &&
      _vm.selectedLocation.nasid &&
      _vm.selectedLocation.nasid > 0
        ? _c(
            "div",
            [
              _vm.manageOrValue == "manage"
                ? _c("Settings", {
                    key: "basicSettings::" + _vm.selectedLocation.nasid,
                    attrs: {
                      storeData: _vm.storeData,
                      selectedLocation: _vm.selectedLocation,
                      selectTab: _vm.selectTab,
                      settingId: _vm.settingId
                    },
                    on: {
                      troubleshoot: function($event) {
                        _vm.showTroubleShooting = true
                      },
                      "got-inactive-locations": function($event) {
                        return _vm.$emit("got-inactive-locations", $event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.selectedSection == "value" &&
      _vm.selectedLocation.nasid &&
      _vm.selectedLocation.nasid > 0
        ? _c(
            "div",
            [
              _c(
                "v-tabs",
                {
                  attrs: {
                    color: "#f26547",
                    "background-color": "transparent",
                    grow: ""
                  },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c(
                    "v-tab",
                    {
                      staticClass: "fs-14 fw-400 text-capitalize",
                      staticStyle: {
                        "font-weight": "500",
                        "font-size": "16px",
                        "font-family": "inherit",
                        "letter-spacing": "normal"
                      }
                    },
                    [_vm._v("Promote")]
                  ),
                  _c(
                    "v-tab",
                    {
                      staticClass: "fs-14 fw-400 text-capitalize fs-16",
                      staticStyle: {
                        "font-weight": "500",
                        "font-size": "16px",
                        "font-family": "inherit",
                        "letter-spacing": "normal"
                      }
                    },
                    [_vm._v("Report")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    [
                      _c("Promote", {
                        key:
                          "promote::" +
                          _vm.selectedLocation.nasid +
                          "::" +
                          _vm.selectedSection,
                        attrs: {
                          storeData: _vm.storeData,
                          selectedLocation: _vm.selectedLocation,
                          settingId: _vm.settingId
                        },
                        on: {
                          "save-promote": function($event) {
                            return _vm.savePromote($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    [
                      _c("Reports", {
                        key: "reports::" + _vm.selectedLocation.nasid,
                        attrs: {
                          storeData: _vm.storeData,
                          selectedLocation: _vm.selectedLocation,
                          settingId: _vm.settingId
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }